// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rp-0";